// Public browser configuration only. Never add secret or service-role keys here.
window.FAMILY_CIRCLE_AUTH = Object.freeze({
  url: 'https://bnkiwfbjqtczwgezzhnm.supabase.co',
  publishableKey: 'sb_publishable_SU_4WGVEGhbBzhyi8---dQ_0qVQy8dG',
  // Public VAPID key only; the signing key is stored in Supabase function secrets.
  pushVapidPublicKey: 'BAhZlRzxXuO3Hcpulf9G9TrtPEBLVwnQaUV2LT_bkbM33I5AV3-5Sq7UEE-bdmwJMh04CexO31ptKGWCqNyLyY4'
});
